<template lang="pug">
  b-container
    h4.mb-0 {{contact.full_name}}
    p.text-secondary {{contact.email}}
    b-tabs
      b-tab.mt-3(title="Contacto", active)
        b-card.shadow
          b-form-group(label="Asesor asignado")
            treeselect(:options="admins", placeholder="-- Seleccionar administrador --", v-model="contact.assigned_admin_id", v-bind="treeselect_options", :clearable="false", )
          b-form-row.mb-2
            b-col(md="6")
              b-form-group(label="Etapa de trato")
                b-form-radio-group(v-model="contact.stage", :options="stage_options", @change="updateContact", buttons, button-variant="outline-primary")
            b-col(md="6")
              b-form-group(label="Etiqueta")
                b-dropdown(size="sm", v-bind="contact.tag ? tags[contact.tag] : tags.client", :menu-class="['filters-dropdown']")
                  b-dropdown-form
                    b-form-radio-group(v-model="contact.tag", :options="tag_options", @change="updateContact", stacked)
          p.text-secondary.mb-0 Creado {{contact.origin ? origins[contact.origin] : origins.other}}
        b-card.shadow
          b-link.text-reset.h5(v-b-toggle="'details'")
            h5.mb-0 Información
              chevron-down-icon.ml-1.icon-md
          b-collapse.mt-2(id="details", visible)
            b-form-row.mb-3
              b-col(md="7")
                b-form-group(label="Nombre", label-size="sm")
                  b-input-group
                    b-input-group-prepend
                      b-form-select.border-right-0(v-model="contact.title")
                        option.text-secondary(value="", disabled) Título
                        option(v-for="t in titles", :key="t", :value="t") {{t}}
                    b-form-input(v-model="contact.first_name" name="name" placeholder="Nombre", trim, :state="contact.first_name ? null : (data_validated ? false : null)")
              b-col(md="5")
                b-form-group(label="Apellido", label-size="sm")
                  b-form-input(v-model="contact.last_name", placeholder="Apellido", trim, :state="contact.last_name ? null : (data_validated ? false : null)")
            b-form-row.mb-3
              b-col(md="6")
                b-form-group(label="Fehca de nacimiento", label-size="sm")
                  date-range-picker.w-100.p-0.b-0(ref="date_picker_input", v-bind="calendar_props", v-model="picked_date", @update="datePicked")
                    template.w-100(v-slot:input="picker")
                      b-input-group.mb-3(id="date_picker_input")
                        b-form-input.readonly-white(placeholder="Seleccionar fecha...", :value="pickedDateFormatted", readonly)
                        b-input-group-append
                          b-input-group-text
                            calendar-icon.text-secondary.icon-sm
              b-col(md="6")
                b-form-group(label="RFC", label-size="sm")
                  b-form-input(v-model="contact.rfc", placeholder="RFC", trim)
            b-form-group(label="Dirección", label-size="sm")
              b-form-textarea(v-model="contact.address", placeholder="Dirección", trim, no-resize, rows="2", max-rows="5")
        b-card.shadow
          b-link.text-reset.h5(v-b-toggle="'contact'")
            h5.mb-0 Contacto
              chevron-down-icon.ml-1.icon-md
          b-collapse.mt-2(id="contact", visible)
            b-form-group(label="Correo", label-size="sm")
              b-form-input(v-model="contact.email", name="email", placeholder="Correo", trim, :state="contact.email ? null : (data_validated ? false : null)")
            b-form-row.mb-3
              b-col(md="6")
                b-form-group(label="Num. teléfono", label-size="sm")
                  b-form-input(v-model="contact.phone", placeholder="Teléfono", trim)
              b-col(md="6")
                b-form-group(label="Num. celular", label-size="sm")
                  b-form-input(v-model="contact.cell_phone", placeholder="Celular", trim)
            b-form-group(label="Plataforma principal", description="Plataforma por donde es más fácil contactar a la persona")
              b-form-select(v-model="contact.main_platform")
                option(value="", disabled) -- Seleccionar plataforma --
                option(v-for="plat in platforms", :key="plat.platform_id", :value="plat.name") {{plat.title}}
        b-card.shadow
          b-link.text-reset.h5(v-b-toggle="'enterprise'")
            h5.mb-0 Organización
              chevron-down-icon.ml-1.icon-md
          b-collapse.mt-2(id="enterprise", visible)
            b-form-group(label="Empresa", label-size="sm")
              b-form-input(v-model="contact.commercial_name", placeholder="Empresa", trim)
            b-form-group(label="Dirección empresarial", label-size="sm")
              b-form-textarea(v-model="contact.business_address", placeholder="Dirección empresarial", trim, no-resize, rows="2", max-rows="5")

        b-row.justify-content-center
          b-col.mt-3.mb-5(cols="10")
            b-button(variant="primary", block, size="lg", :disable="loading", @click="updateContact") Guardar cambios
      b-tab.mt-3(title="Notas")
        .text-right.mb-3
          b-button(variant="primary", @click="addNote", :disabled="loading")
            span(v-if="!loading") Agregar nota
            b-spinner(variant="light", small, v-else, type="grow")
        empty-message(message="No se han agregado notas", v-if="!notes.length")
        b-card.shadow.mb-3.text-right(v-for="(note, index) in notes", :key="index")
          b-form-textarea(placeholder="Nota...", v-model.trim="note.value", rows="2", @input="updateNote(note)", :disabled="note.loading")
          b-link.text-danger.text-sm(@click="deleteNote(note, index)", :disabled="note.loading") Eliminar nota
      b-tab.mt-3(title="Información adicional")
        .text-right.mb-3
          b-button(variant="primary", @click="addCustomData", :disabled="loading")
            span(v-if="!loading") Agregar información
            b-spinner(variant="light", small, v-else, type="grow")
        empty-message(message="No se ha agregado información adicional", v-if="!custom_data.length")
        b-form-row(v-else)
          b-col(md="5")
            p.mb-1 Nombre:
          b-col(md="7")
            p.mb-1 Dato:
        b-form-row.mb-2(v-for="(c_data, index) in custom_data", :key="index")
          b-col(md="5")
            b-form-input(v-model="c_data.name", placeholder="Nombre...", @input="updateData(c_data)")
          b-col(md="7")
            b-input-group
              b-form-input(v-model="c_data.value" placeholder="Dato...", trim, @input="updateData(c_data)")
              b-input-group-append
                b-button(variant="soft-danger", size="sm" @click="deleteCustomData(c_data, index)", :disabled="c_data.loading")
                  b-spinner(small, variant="primary", v-if="c_data.loading")
                  trash-2-icon.icon-sm.text-secondary(v-else)
      b-tab.mt-3(v-if="contact.conversations.length", title="Conversaciones")
        b-row
          b-col(md="7", v-for="conversation in contact.conversations", :key="conversation._id")
            chat-row(v-bind="conversation", :can_select="false", target_blank, inbox)


</template>

<script>
import { createNamespacedHelpers, mapActions } from 'vuex'
const platformController = createNamespacedHelpers('platform')
const accountController = createNamespacedHelpers('account')
import _debounce from 'lodash.debounce'
import Days from "@/data/days";
import Months from "@/data/months";
import treeselectOptions from '@/data/treeselect-options'
import ChatRow from "./ChatRow";

export default {
  data () {
    return {
      treeselect_options: treeselectOptions,
      loading: false,
      titles: ['Sra.', 'Srta.', 'Sr.', 'Lda.', 'Ldo.', 'Dra.', 'Dr.'],
      data_validated: false,
      calendar_props: {
        singleDatePicker: true,
        ranges: false,
        localeData: {
          applyLabel: 'Aplicar',
          cancelLabel: 'Cancelar',
          daysOfWeek: Days.daysShort,
          monthNames: Months.monthsShort,
          firstDay: 0
        }
      },
      picked_date: {
        startDate: null,
        endDate: null
      },
      contact: {
        account_id: '',
        first_name: '',
        last_name: '',
        full_name: '',
        commercial_name: '',
        email: '',
        phone: '',
        cell_phone: '',
        rfc: '',
        birthday: '',
        address: '',
        business_address: '',
        title: '',
        stage: 0,
        tag: '',
        admin: null,
        origin: '',
        main_platform: '',
        assigned_admin_id: null,
        custom_data: [],
        platforms: [],
        notes: [],
        conversations: []
      },
      stages: {
        created: "Nuevo",
        qualified: "Evaluado",
        contacted: "Contactado",
        negotiation: "En negociación",
        closed: "Cerrado"
      },
      stage_options: [
        { text: 'Nuevo', value: 'created' },
        { text: 'Evaluado', value: 'qualified' },
        { text: 'Contactado', value: 'contacted' },
        { text: 'En negociación', value: 'negotiation' },
        { text: 'Cerrado', value: 'closed' }
      ],
      origins: {
        dashboard: "en socialkit",
        chatbot: "a través de chatbot",
        other: "en otro medio"
      },
      tags: {
        client: {text: "Cliente", variant: "info"},
        high: {text: "Muy interesado", variant: "success"},
        medium: {text: "Algo interesado", variant: "warning"},
        low: {text: "Poco interesado", variant: "danger"},
      },
      tag_options: [
        { text: 'Cliente', value: 'client' },
        { text: 'Muy interesado', value: 'high' },
        { text: 'Algo interesado', value: 'medium' },
        { text: 'Poco interesado', value: 'low' }
      ],
    }
  },
  props: {
    contact_id: {
      type: String,
      default: null
    }
  },
  computed: {
    ...accountController.mapState({
      admins: state => state.admins.map(el => {
        return {
          id: el.admin_id,
          label: `${el.first_name} ${el.last_name} (${el.email})`
        }
      })
    }),
    ...platformController.mapState({
      platforms: state => state.all_platforms
    }),
    pickedDateFormatted () {
      return this.contact.birthday ? this.$moment(this.contact.birthday).format('DD MMMM YYYY') : ''
    },
    custom_data () {
      return this.contact.custom_data.map(c => {
        c.loading = false
        return c
      })
    },
    notes () {
      return this.contact.notes ? this.contact.notes.map(el => {
        el.loading = false
        return el
      }) : []
    },
  },
  methods: {
    ...mapActions(['contact/get', 'contact/update', 'contact/addCustomData', 'contact/updateCustomData', 'contact/deleteCustomData',
                   'contact/addNote', 'contact/updateNote', 'contact/removeNote']),
    getContact () {
      this.loading = true
      let self = this
      this['contact/get']({
        contact_id: self.contact_id,
        callback: res => {
          self.loading = false
          if (res.error) {
            self.$message.error(res.error)
          } else {
            self.contact = Object.assign(self.contact, res.resource)
          }
        }
      });
    },
    updateContact () {
      this.loading = true
      let self = this
      this['contact/update']({
        contact_id: self.contact_id,
        ...this.contact,
        callback: res => {
          self.loading = false
          if (res.error) {
            self.$message.error(res.error)
          } else {
            self.$message.success('Contacto actualizado')
          }
        }
      });
    },
    addCustomData () {
      this.loading = true
      let self = this
      this['contact/addCustomData']({
        contact_id: self.contact_id,
        name: '',
        value: '',
        callback: res => {
          self.loading = false
          if (res.error) {
            self.$message.error(res.error)
          } else {
            res.resource.loading = false
            self.contact.custom_data.push(res.resource)
          }
        }
      });
    },
    updateData: _debounce(function (custom_data) {
      custom_data.loading = true
      let self = this
      this['contact/updateCustomData']({
        contact_id: self.contact_id,
        ...custom_data,
        callback: res => {
          custom_data.loading = false
          if (res.error) {
            self.$message.error(res.error)
          }
        }
      });
    },1000,{leading: false, trailing: true}),
    deleteCustomData (custom_data, index) {
      custom_data.loading = true
      let self = this
      this['contact/deleteCustomData']({
        contact_id: self.contact_id,
        ...custom_data,
        callback: res => {
          self.loading = false
          if (res.error) {
            self.$message.error(res.error)
          } else {
            self.contact.custom_data.splice(index, 1)
          }
        }
      });
    },
    datePicked (dates) {
      this.contact.birthday = dates.startDate
    },
    scrollToTop () {
      this.$scrollTo('#contact-info', 500, {
        container: '#contact-info',
        offset: -20
      })
    },
    addNote () {
      this.loading = true
      let self = this
      this['contact/addNote']({
        contact_id: self.contact_id,
        callback: res => {
          self.loading = false
          if (res.error) {
            self.$message.error(res.error)
          } else {
            res.resource.loading = false
            self.contact.notes ? self.contact.notes.push(res.resource) : self.contact.notes = [res.resource]
          }
        }
      });
    },
    updateNote: _debounce(function (note) {
      note.loading = true
      let self = this
      this['contact/updateNote']({
        contact_id: self.contact_id,
        ...note,
        callback: res => {
          note.loading = false
          if (res.error) {
            self.$message.error(res.error)
          }
        }
      });
    },1000,{leading: false, trailing: true}),
    deleteNote (note, index) {
      note.loading = true
      let self = this
      this['contact/removeNote']({
        contact_id: self.contact_id,
        ...note,
        callback: res => {
          self.loading = false
          if (res.error) {
            self.$message.error(res.error)
          } else {
            self.contact.notes.splice(index, 1)
          }
        }
      });
    },
  },
  mounted () {
    this.getContact()
  },
  components: {ChatRow}
}
</script>

<style lang="scss">

</style>
